// import { UserService } from '../../services/api.service';
// import AuthService from '../../services/auth.service';

// action types
const TYPES = {
  SET_TOKEN: 'SET_TOKEN', // 设置token
 
}

// initial state
const state = {
  token:'66666666666666',
}



// actions
const actions = {
  
  //设置token
  setToken ({ commit }, token={}) {
    commit(TYPES.SET_TOKEN, token)
  }

}

// mutations
const mutations = {
  
  [TYPES.SET_TOKEN] (state, token) {
    state.token = token
    AuthService.setToken(token)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js